import React from "react";
import Classes from "../components/Classes/Classes";

const AllClass = () => {
  return <Classes />;
};

export default AllClass;
